/* eslint-disable no-unused-vars */
import {
  get_toc_m as get_toc,
  get_toc_name_m as get_toc_name,
} from "./mockapi.js";

import {
  get_journal,
  view_article,
  get_login_by_ip,
  refresh_token,
  get_journal_vols,
  get_indexed_artis,
  get_login_by_user,
  generic_api,
  qq_export,
} from "./prodapi.js";

import { toc_options, jinfo } from "@/site_settings"
const mainsets = []
const default_search_setsn = []
for(let i = 0; i < toc_options.length; i++) {
  let v = toc_options[i]
  let setsn = v.id.split('_')[0]
  mainsets.push(setsn)
  if(setsn == 'waa') {
    default_search_setsn.push('wai')
  }
  else {
    default_search_setsn.push(setsn)
  }
}
default_search_setsn.sort()

export {
  toc_options,
  jinfo,
  mainsets,
  default_search_setsn,
  get_toc,
  get_journal,
  get_toc_name,
  view_article,
  get_login_by_ip,
  refresh_token,
  get_journal_vols,
  get_indexed_artis,
  get_login_by_user,
  generic_api,
  qq_export,
};
